import React from 'react'
import { css, useTheme } from '@emotion/react'

function Button({
    children,
    type = 'default',
    btnColor,
    size,
    style,
    onClick
}) {
    const theme = useTheme()
    const color = theme?.colors
    const primary = {
        default: {
            color: color.white,
            bgColor: color.primary
        },
        outlined: {
            color: color.primary,
            hoverBgColor: color.primary
        }
    }
    const buttonSize = (bSize) => {
        switch (bSize) {
            case 'x-small':
                return `
                    font-size: ${theme.fontSize.xs};
                    padding: 0.25rem;
                `
            case 'small':
                return `
                    font-size: ${theme.fontSize.sm};
                    padding: 0.25rem 0.5rem;
                `
            case 'medium':
                return `font-size: ${theme.fontSize.base}; 
                        padding: 0.5rem 2rem;
                `
            case 'large':
                return `
                    font-size: ${theme.fontSize.lg}; 
                    padding: 1rem 3rem;
                `
            default:
                return `
                    font-size: ${theme.fontSize.base}; 
                    padding: 0.5rem 2rem;
                `
        }
    }
    const buttonStyle = css`
        display: flex;
        justify-content: center;
        align-items: center;
        ${buttonSize(size)};
        ${type === 'default' &&
        `color: ${color[btnColor]?.default?.color || primary?.default?.color}`};
        ${type === 'default' &&
        `background-color: ${
            color[btnColor]?.default.bgColor || primary?.default?.bgColor
        }`};
        ${type === 'outlined' &&
        `color: ${
            color[btnColor]?.outlined?.color || primary?.outlined?.color
        }`};
        ${type === 'outlined' && 'background-color: transparent'};
        ${type === 'outlined' &&
        `border: 1px solid ${
            color[btnColor]?.outlined?.color || primary?.outlined?.color
        }`};
        &:hover {
            filter: contrast(120%) brightness(120%);
            ${type === 'outlined' &&
            `filter: drop-shadow(0 0 4px ${
                color[btnColor]?.outlined?.hoverBgColor ||
                primary?.outlined?.hoverBgColor
            }`});
        }
        ${style}
    `
    return (
        <button onClick={onClick} css={buttonStyle}>
            {children}
        </button>
    )
}

export default Button
